import React, { Component }     from "react";
import { RecentRegistrations }  from 'components/admin/Admin/RecentRegistrations';

import AuthService              from 'services/auth.service';
import AdminsService            from 'services/admins.service';
import './../../assets/styles/Customer.scss';

import PreviousBtn              from 'assets/images/Previous.svg';
import NextBtn                  from 'assets/images/Next.svg';

class Upcoming extends Component {
  constructor(props){
    super(props);
    this.state = {
      stores: [],
      registrations: [],
      start_date: '',
      end_date: '',
      page: 1,
      total_pages: 1
    }
  }

  reloadList() {
    const params = {
      start_date: this.state.start_date,
      end_date:   this.state.end_date,
      page:       this.state.page
    }

    AdminsService.upcoming(params).then(
      (data) => {
        this.setState({
          stores: data.stores,
          registrations: data.registrations,
          start_date: data.start_date,
          end_date: data.end_date,
          page: data.meta.current_page,
          total_pages: data.meta.total_pages
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/admin/login');
        }
      }
    );
  }

  componentDidMount() {
    this.reloadList();
  }

  handleSearch() {
    if (this.state.start_date && this.state.end_date) {
      this.reloadList();
    } else {
      alert('Must have both start date and end date');
    }
  }

  handlePage(previous) {
    let pageNumber    = this.state.page;
    const totalPages  = this.state.total_pages;

    if (previous) {
      pageNumber = pageNumber === 1 ? 1 : pageNumber - 1;
    } else {
      pageNumber = pageNumber === totalPages ? totalPages : pageNumber + 1;
    }

    this.setState({ page: pageNumber }, this.reloadList);
  }

  displayRegistrations() {
    let mapped = this.state.registrations.length > 0 ?
      this.state.registrations.map((array, index) => {
        return <div key={ index } className="mt-4">
          <h5>{ array[0] ? array[0] : 'No date' }</h5>
          <RecentRegistrations items={ array[1] } handleReload={() => this.reloadList() } />
        </div>
      }) : <h5 className="mt-4">No registrations found</h5>

    return mapped;
  }

  render() {
    return (
      <div className="admin-page">
        <h4 style={{ fontWeight: 'bold' }}>Upcoming</h4>

        <div className="d-flex align-items-center">
          <input type="date" placeholder="" name="start_date"
            value={ this.state.start_date }
            onChange={(e) => this.setState({ start_date: e.target.value }) }
            className="form-control"
            style={{ width: '20em' }}
          />

          <span className="mx-3">to</span>

          <input type="date" placeholder="" name="end_date"
            value={ this.state.end_date }
            onChange={(e) => this.setState({ end_date: e.target.value }) }
            className="form-control"
            style={{ width: '20em' }}
          />

          <button
            className="btn btn-primary ms-3 px-4"
            style={{ border: '1px solid #233577', background: '#233577', fontWeight: '800' }}
            onClick={() => this.handleSearch() }
          >
            Filter
          </button>

          <div className="flex-grow-1"></div>

          <label className="ml-sm-4 my-2 my-sm-0 mb-0">
            <button onClick={() => this.handlePage(true) } style={{ border: "none", backgroundColor: "#e9ebff" }}>
              <img src={ PreviousBtn } alt="previous" className="page-prev-btn" />
            </button>

            <b className="font-size-6 px-2">{ this.state.page } of { this.state.total_pages }</b>

            <button onClick={() => this.handlePage(false) } style={{ border: "none", backgroundColor: "#e9ebff" }}>
              <img src={ NextBtn } alt="next" className="page-next-btn" />
            </button>
          </label>
        </div>

        <div style={{ fontSize: '0.8em' }}>
          { this.displayRegistrations() }
        </div>
      </div>
    );
  }
}

export { Upcoming };